module.exports = __webpack_public_path__ + "img/nature5.2204ac07.jpg";